"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.continueConversation = continueConversation;
exports.startConversation = startConversation;
exports.submitCsat = submitCsat;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

// All requests go through the backend proxy (see SearchController::forethought*Action),
// which reads the per-community Solve API token from DynamoDB and forwards to
// https://app.forethought.ai/solve/api/v1. The token never reaches the browser.
var PROXY_START = '/search/forethoughtConversation';
var PROXY_CONTINUE = '/search/forethoughtConversationContinue';
var PROXY_CSAT = '/search/forethoughtCsat';

function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-CSRF-Token': (0, _csrfToken.csrfToken)()
  };
} // Pull the most useful error string out of an upstream non-2xx response.
// The proxy returns `{"error": "..."}` for its own failures (403/422/503/502);
// Forethought itself returns `{"status", "message", "detail"}`. Either way, a
// stray HTML error page should not crash the parse.


function extractErrorMessage(status, rawBody, contentType) {
  var trimmed = rawBody.trim();

  if (trimmed && (contentType !== null && contentType !== void 0 ? contentType : '').toLowerCase().includes('application/json')) {
    try {
      var parsed = JSON.parse(trimmed);
      var candidates = ['error', 'message', 'detail'];

      for (var _i = 0, _candidates = candidates; _i < _candidates.length; _i++) {
        var key = _candidates[_i];
        var value = parsed[key];

        if (typeof value === 'string' && value) {
          return value;
        }
      }
    } catch (_unused) {// fall through to raw text
    }
  }

  if (trimmed) {
    return trimmed.length > 240 ? "".concat(trimmed.slice(0, 240), "\u2026") : trimmed;
  }

  return "HTTP ".concat(status);
} // Confirm the parsed body matches the Forethought conversation contract before
// handing it to the renderer. Catches proxy mis-responses (HTML error pages,
// `{"error": "..."}` returned with a 200, empty bodies, etc.) so the UI surfaces
// a clean error instead of crashing on a missing field.


function isConversationResponse(value) {
  if (!value || (0, _typeof2.default)(value) !== 'object') return false;
  var v = value;
  return typeof v.conversation_id === 'string' && Array.isArray(v.widget_components);
}

function safeReadJson(_x) {
  return _safeReadJson.apply(this, arguments);
}

function _safeReadJson() {
  _safeReadJson = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
    var text;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return response.text();

          case 2:
            text = _context.sent;

            if (text) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", null);

          case 5:
            _context.prev = 5;
            return _context.abrupt("return", JSON.parse(text));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", text);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 9]]);
  }));
  return _safeReadJson.apply(this, arguments);
}

function timedFetch(_x2, _x3) {
  return _timedFetch.apply(this, arguments);
}

function _timedFetch() {
  _timedFetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url, init) {
    var startedAt, response, responseTimeMs, contentType, body, parsed, preview;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            startedAt = Date.now();
            _context2.next = 3;
            return fetch(url, init);

          case 3:
            response = _context2.sent;
            responseTimeMs = Date.now() - startedAt;
            contentType = response.headers.get('Content-Type');

            if (response.ok) {
              _context2.next = 17;
              break;
            }

            body = '';
            _context2.prev = 8;
            _context2.next = 11;
            return response.text();

          case 11:
            body = _context2.sent;
            _context2.next = 16;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](8);

          case 16:
            throw new Error("Forethought ".concat(response.status, ": ").concat(extractErrorMessage(response.status, body, contentType)));

          case 17:
            _context2.next = 19;
            return safeReadJson(response);

          case 19:
            parsed = _context2.sent;

            if (isConversationResponse(parsed)) {
              _context2.next = 23;
              break;
            }

            preview = typeof parsed === 'string' ? parsed : JSON.stringify(parsed);
            throw new Error("Forethought proxy returned an unexpected response shape: ".concat(preview ? preview.slice(0, 240) : 'empty body'));

          case 23:
            return _context2.abrupt("return", {
              data: parsed,
              responseTimeMs: responseTimeMs
            });

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 14]]);
  }));
  return _timedFetch.apply(this, arguments);
}

function startConversation(_x4, _x5) {
  return _startConversation.apply(this, arguments);
}

function _startConversation() {
  _startConversation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(query, signal) {
    var body;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            body = {
              stream: false,
              query: query,
              context_variables: {}
            };
            return _context3.abrupt("return", timedFetch((0, _absoluteUrlRuntime.resolveUrl)(PROXY_START), {
              method: 'POST',
              headers: buildHeaders(),
              body: JSON.stringify(body),
              signal: signal
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _startConversation.apply(this, arguments);
}

function continueConversation(_x6, _x7) {
  return _continueConversation.apply(this, arguments);
}

function _continueConversation() {
  _continueConversation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(conversationId, query) {
    var contextVariables,
        signal,
        body,
        url,
        _args4 = arguments;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            contextVariables = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            signal = _args4.length > 3 ? _args4[3] : undefined;
            body = {
              stream: false,
              query: query,
              context_variables: contextVariables
            };
            url = "".concat((0, _absoluteUrlRuntime.resolveUrl)(PROXY_CONTINUE), "?id=").concat(encodeURIComponent(conversationId));
            return _context4.abrupt("return", timedFetch(url, {
              method: 'PUT',
              headers: buildHeaders(),
              body: JSON.stringify(body),
              signal: signal
            }));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _continueConversation.apply(this, arguments);
}

function submitCsat(_x8, _x9, _x10, _x11) {
  return _submitCsat.apply(this, arguments);
}

function _submitCsat() {
  _submitCsat = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(conversationId, rating, feedback, signal) {
    var body, url, response;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            body = {
              rating: rating
            };
            if (feedback) body.feedback = feedback;
            url = "".concat((0, _absoluteUrlRuntime.resolveUrl)(PROXY_CSAT), "?id=").concat(encodeURIComponent(conversationId));
            _context5.next = 5;
            return fetch(url, {
              method: 'POST',
              headers: buildHeaders(),
              body: JSON.stringify(body),
              signal: signal
            });

          case 5:
            response = _context5.sent;

            if (response.ok) {
              _context5.next = 8;
              break;
            }

            throw new Error("CSAT submission failed: ".concat(response.status));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _submitCsat.apply(this, arguments);
}